import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { AcceptanceFlows } from 'src/app/flows/acceptance.flows';
import { AuthFlows } from 'src/app/flows/auth.flows';
import { UserFlows } from 'src/app/flows/user.flows';

@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
  standalone: false
})
export class LoginCardComponent implements OnInit {
  loading;
  @Input() returnPath: string = '/';
  @Input() embassadorCase: boolean = false;

  constructor(
    public router: Router,
    private userFlows: UserFlows,
    private acceptanceFlows: AcceptanceFlows,
    private loadingController: LoadingController,
    private authFlow: AuthFlows
  ) { }

  ngOnInit() { }

  async doFacebookLogin() {
    if (await this.authFlow.presentAcceptance()) {
      this.presentLoading();
      this.userFlows.doSignupFacebook()
        .then((user) => {
          this.acceptanceFlows.userAcceptance(user);
          this.loading.dismiss();
          this.router.navigate([this.returnPath]);
        })
        .catch(res => {
          console.log('===>> ERROR FB:');
          console.log(res);
          this.authFlow.handleAuthError(res);
          this.loading.dismiss();
        });
    } else {
      throw "error";
    }
  }

  async doGoogleLogin(): Promise<any> {
    if (await this.authFlow.presentAcceptance()) {
      this.presentLoading();
      this.userFlows.doSignupGoogle()
        .then((user: any) => {
          this.acceptanceFlows.userAcceptance(user);
          this.loading.dismiss();
          this.router.navigate([this.returnPath]);
        })
        .catch(res => {
          console.error(res);
          this.authFlow.handleAuthError(res);
          this.loading.dismiss();
        });
    } else {
      throw "error";
    }
  }

  doFormLogin(): void {
    this.router.navigate(['/auth/login'], { queryParams: { returnPath: this.returnPath } });
  }

  async presentLoading() {
    this.loading = await this.loadingController.create({
      message: 'Espera por favor...'
    });
    this.loading.present();
  }
}

